import { Button } from '../ui/Button'
export function FormButton({
  type = 'submit',
  variant = 'primary',
  size = 'md',
  children,
  className = '',
  disabled = false,
  loading = false,
  ...props
}) {
  return (
    <Button
      type={type}
      variant={variant}
      size={size}
      disabled={disabled}
      loading={loading}
      className={className}
      {...props}
    >
      {children}
    </Button>
  )
}
